<template>
  <div class="home">
    <nav>
      <Tabs :activeIndex="0" />
    </nav>
    <header class="banner">
      <el-carousel autoplay height="90vh">
        <el-carousel-item v-for="(item,index) in bannerList" :key="index">
          <video v-if="item.image.substr(item.image.lastIndexOf('.')+1)=='mp4'" class="banner-image" autoplay loop>
            <source :src="item.image" type="video/mp4" />
          </video>
          <img v-else class="banner-image" :src="item.image" alt="" />
        </el-carousel-item>
      </el-carousel>
    </header>
    <main class="main-top">
      <!-- <div class="main-title">优势</div> -->
      <div class="content">
        <img style="width: 100%;display: block;" src="@/assets/home/advantage.jpg" alt="">
      </div>
    </main>
    <main class="main-top">
      <!-- <div class="main-title">应用场景</div> -->
      <div class="content">
        <img style="width: 100%;display: block;" src="@/assets/home/industry.jpg" alt="">
      </div>
    </main>
    <main class="main-top">
      <!-- <div class="main-title">问题与回答</div> -->
      <div class="content">
        <img style="width: 100%;display: block;" src="@/assets/home/type.jpg" alt="">
      </div>
    </main>
    <main class="main-top">
      <!-- <div class="main-title">视频展示</div> -->
      <div class="content">
        <img style="width: 100%;display: block;" src="@/assets/home/questions.jpg" alt="">
      </div>
    </main>
    <main class="main-top">
      <!-- <div class="main-title">人工智能大模型</div> -->
      <div class="content">
        <img style="width: 100%;display: block;" src="@/assets/home/video-img.png" alt="">
      </div>
    </main>
    <main class="main-center">
      <div class="main-title">易信网络</div>
      <div class="content">
        <div class="content-img" style="margin-bottom: 4rem;">
          <img src="@/assets/home/sjzcgl.png" alt="">
        </div>
        <div class="content-text">
          河南易信网络，是国内领先的数字化软件技术服务商，致力于为客户提供高品质的软件技术服务，业务包括数字化战略咨询、云产品与解决方案、软件研发、IT技术服务。河南易信网络以客户满意为奋斗目标，与众多品牌企业客户建立长期战略伙伴关系。
        </div>
      </div>
    </main>
    <!-- <main class="main-bottom">
      <img src="http://61.171.98.232:9002/portalweb/bottom-img.png" alt="">
    </main> -->
    <BottomView />
  </div>
</template>

<script setup name="HomeView">
import Tabs from '@/components/homeTabs'
import BottomView from '@/components/bottomView.vue';
import { ref, onBeforeUnmount } from 'vue'
// 轮播图列表
const bannerList = ref([
  // { image: 'http://61.171.98.232:9002/portalweb/banner1.mp4', text: '轮播图0' },
  { image: require('@/assets/home/banner1.jpg'), text: '轮播图1' },
  { image: require('@/assets/home/banner2.jpg'), text: '轮播图2' },
  { image: require('@/assets/home/banner-1.png'), text: '轮播图3' },
  { image: require('@/assets/home/banner4.png'), text: '轮播图4' },
  { image: require('@/assets/home/banner-3.png'), text: '轮播图5' },
])
// 监听页面滚动事件
window.addEventListener('scroll', () => {
  // 获取页面滚动距离
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  if (scrollTop > 0) {
    // 显示顶部导航栏
    document.querySelector('nav').style.background = 'rgba(255, 255, 255, 0.4)';
  } else {
    // 隐藏顶部导航栏
    document.querySelector('nav').style.background = 'rgba(255, 255, 255, 1)';
  }
})
onBeforeUnmount(() => {
  window.removeEventListener('scroll', () => {})
})
</script>
<style scoped lang="scss">
.home {
  // width: 100vw;
  .banner {
    width: 100vw;
    // height: 100vh;
    margin-top: 5.625rem;
    .banner-image {
      width: 100vw;
      // height: 100vh;
      background: #000;
      color: #fff;
      font-size: 5rem;
    }
  }
  nav {
    width: 100%;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    padding: 0;
  }
  .main-title {
    font-size: 5rem;
    font-weight: bold;
    margin-bottom: 2.5rem;
    text-align: left;
    color: #000;
  }
  .main-top {
    width: 82vw;
    margin: 0 auto;
    margin-top: 2rem;
    .content {
      display: flex;
      justify-content: space-between;
      align-content: space-between;
      flex-wrap: wrap;
      .content-img {
        height: 30.875rem;
        border-radius: 1.6rem;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .content-img-one {
        width: 56%;
      }
      .content-img-two {
        width: calc(100% - 56% - 2rem);
      }
    }
  }
  .main-center {
    width: 65vw;
    margin: 2rem auto;
    .content {
      .content-img {
        width: 100%;
        box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.5);
        img {
          width: 100%;
          display: block;
        }
      }
      .content-text {
        font-size: 2rem;
        text-align: left;
      }
    }
  }
  .main-bottom {
    width: 100%;
    img {
      width: 100%;
      display: block;
    }
  }
}
</style>
